import styled from 'styled-components';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import { themeColor } from '@hud/web-components/theme/colors';
import { xxsBold } from '@hud/web-components/theme/typography';

export const CellIcon = styled(HudIcon)`
  color: ${themeColor('textTertiary')};
`;

export const EntityWithIconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TypeLabel = styled.div`
  ${xxsBold};
  border-radius: 4px;
  background: ${themeColor('buttonBackground')};

  display: flex;
  gap: 2px;
  align-items: center;
  padding: 2px 6px;

  margin-left: 4px;
`;
